export const RESERVATION = '€'
export const CUSTOMER = '@'



// WEBPACK FOOTER //
// src/constants/BarcodePrefix.js